module.exports = __webpack_public_path__ + "img/battery-full.6fdfcec0.svg";